import { render, staticRenderFns } from "./AdminWorkspacesFromDomains.vue?vue&type=template&id=1162d99b&scoped=true"
import script from "./AdminWorkspacesFromDomains.vue?vue&type=script&lang=ts"
export * from "./AdminWorkspacesFromDomains.vue?vue&type=script&lang=ts"
import style0 from "./AdminWorkspacesFromDomains.vue?vue&type=style&index=0&id=1162d99b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162d99b",
  null
  
)

export default component.exports